import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../config/apiConfig';


export async function getCategorias(setLoading = false) {
    if (setLoading) setLoading(true);
    const token = localStorage.getItem("token");
    try {
        const resp = await axios.get(`${config.api_url}/api/categorias`, {
            headers: { 'token': token }
        });
        const raw = Array.isArray(resp.data) ? resp.data : (resp.data.categorias || []);
        return raw.map(d => ({ id: d.id, nombre: d.nombre, imagen: d.imagen }));
    } catch (err) {
        const status = err.response && err.response.status;
        if (localStorage.getItem('token') && status !== 401) toast.error("Se ha producido un error al cargar el listado de categorías.");
        return [];
    } finally {
        if (setLoading) setLoading(false);
    }
}

export const eliminarCategoria = async (id) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${config.api_url}/api/categorias/${id}`, {
        method: 'DELETE',
        headers: {
            'token': token,
            'Content-Type': 'application/json'
        }
    });
    return await response.json();
};

/*
 *Categorias 
 */


export const obtenerCategorias = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token no disponible.");
    
    const url = `${config.api_url}/api/categorias`; 
    try {
        const respuesta = await axios.get(url, {
            headers: { "token": token }
        });
        return respuesta.data; // Espera [{ id: 1, nombre: 'Hamburguesas' }, ...]
    } catch (error) {
        let mensajeError = 'Fallo al cargar categorías.';
        if (error.response && error.response.data && error.response.data.error) {
            mensajeError = error.response.data.error;
        }
        throw new Error(mensajeError);
    }
};

export const obtenerCategoriasTPV = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token no disponible.");
    
    const url = `${config.api_url}/api/categorias/tpv`; 
    
    try {
        const respuesta = await axios.get(url, {
            headers: { "token": token }
        });
        console.log("respuesta categorias", respuesta)
        return respuesta.data; // Espera [{ id: 1, nombre: 'Hamburguesas' }, ...]
    } catch (error) {
        let mensajeError = 'Fallo al cargar categorías.';
        if (error.response && error.response.data && error.response.data.error) {
            mensajeError = error.response.data.error;
        }
        throw new Error(mensajeError);
    }
};

export const obtenerCategoriasTienda = async (slug) => {
    
    const url = `${config.api_url}/api/categorias/publico/`; 
    try {
        const respuesta = await axios.get(url + slug);
        console.log("respuesta categorias", respuesta.data);
        return respuesta.data; // Espera [{ id: 1, nombre: 'Hamburguesas' }, ...]
    } catch (error) {
        let mensajeError = 'Fallo al cargar categorías.';
        if (error.response && error.response.data && error.response.data.error) {
            mensajeError = error.response.data.error;
        }
        throw new Error(mensajeError);
    }
};

/**
 * Servicio centralizado para persistir categorías
 */
export const guardarCategoria = async (categoryData) => {
    console.log("guardar categoria", categoryData)
    // Si tiene ID es una actualización, si no, es una creación
    const id = categoryData.id;
    const url = id ? `/api/categorias/${id}` : '/api/categorias';

    const method = id ? 'PUT' : 'POST';
    const token = localStorage.getItem("token");
    
    const response = await fetch(config.api_url + url, {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            'token': token
        },
        body: JSON.stringify({
            nombre: categoryData.nombre,
            icono_id: categoryData.icono_id,
            activo: 1, // O déjalo como lo tenías si aún usas este campo
            
            // 🚩 AQUÍ ESTABA EL ERROR CTM, FALTABA MANDAR ESTO AL BACKEND
            mostrar_tpv: categoryData.mostrar_tpv == 1 ? 1 : 0,
            mostrar_web: categoryData.mostrar_web == 1 ? 1 : 0
        })
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.mensaje || 'Error al procesar la categoría');
    }

    return await response.json();
};
